<template>
  <div :class="{'m-0': noMargin}">
    <div :class="{noPadding: noPadding}">
      <div class="form-control-container">
        <select
          v-validate="validate"
          ref="input"
          :name="id"
          :id="id"
          :key="id"
          :class="inputClass"
          :data-vv-as="label.toLowerCase()"
          :value="value"
          :disabled="disabled"
          class="form-control"
          @input="updateValue($event.target.value)"
          @change="onChange($event.target.value)"
        >
          <option :disabled="!enableBlankValue" :selected="value == '' || value == null" value>Type</option>
          <option
            v-for="(option, index) in options"
            :key="index"
            :value="option.value"
            :selected="value == option.value"
          >{{ option.label }}</option>
        </select>
      </div>
      <!--<div
        v-if="validationActive"
        class="form-control-validation is-invalid">
        <i
          v-b-tooltip.topleft.click.hover
          :title="errors.first(`${form}.${id}`)"
          class="material-icons d-flex align-items-center h-100">error_outline</i>
        <div
          class="tooltip bs-tooltip-top show d-none"
          role="tooltip"
          tabindex="-1"
          x-placement="top">
          <div class="arrow"/>
          <div class="tooltip-inner">{{ errors.first(`${form}.${id}`) }}</div>
        </div>
      </div>
      <div
        v-if="value && validationActive"
        class="form-control-validation is-valid">
        <i class="material-icons d-flex align-items-center h-100">check</i>
      </div>
      <div
        v-if="isRequired"
        class="form-control-validation">
        <span class="d-flex align-items-center h-100">*</span>
      </div>-->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import bTooltip from "bootstrap-vue/es/directives/tooltip/tooltip";
import { getParentFormId, fieldReset } from "@/helpers/forms";
import { generateId } from "@/helpers/components";

export default {
  inject: ["$validator"],
  directives: {
    bTooltip
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    },
    inputClass: {
      type: String,
      default: ""
    },
    validate: {
      type: String,
      default: ""
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    inlineBlock: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    enableBlankValue: {
      type: Boolean,
      default: false
    },
    noLabelDisplayed: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    }
  },

  data: function() {
    return {
      form: "",
      id: generateId(),
      value: ""
    };
  },

  computed: {
    isRequired() {
      return this.validate && this.validate.indexOf("required") !== -1;
    },
    validationActive() {
      return this.validate !== "";
    },
    ...mapState("app", ["isFormReset"])
  },
  watch: {
    isFormReset() {
      fieldReset(this.$refs.input);
    }
  },
  mounted() {
    this.form = getParentFormId(this);
  },

  methods: {
    updateValue(value) {
      this.$emit("input", value);
    },

    onChange(taskGUID) {
      this.value = taskGUID;
    }
  }
};
</script>
<style scoped>
.noLabelDisplayed {
  display: none;
}

.noPadding {
  padding: 0px;
}
</style>
